<template>
    <div>
        <v-row v-for="(dateRange, index) in dateRanges" :key="index" no-gutters align="center" class="mb-2 mt-2">
            <v-col cols="auto" class="pr-2" style="width: 160px;">
                <v-menu
                    v-model="dateRange.fromMenuOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateRange.from"
                            label="From"
                            readonly
                            outlined
                            dense
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="dateRange.from"
                        :max="dateRange.to"
                        @input="dateRange.fromMenuOpen = false"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="auto" class="pr-2" style="width: 160px;">
                <v-menu
                    v-model="dateRange.toMenuOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateRange.to"
                            label="To"
                            readonly
                            outlined
                            dense
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="dateRange.to"
                        :min="dateRange.from"
                        @input="dateRange.toMenuOpen = false"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="auto" class="text-center">
                <v-btn icon small @click="removeDateRange(index)" :disabled="dateRanges.length === 1 || disabled" title="Remove date range">
                    <v-icon small>close</v-icon>
                </v-btn>

                <v-btn icon small @click="addDateRange(index)" :disabled="disabled" title="Add date range">
                    <v-icon small>add</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export function newDateRange() {
    return {
        from: '',
        to: '',
        fromMenuOpen: false,
        toMenuOpen: false,
    };
}

export default {
    name: 'ies-date-range-rows',
    props: ['dateRanges', 'disabled'],
    methods: {
        addDateRange: function (index) {
            this.dateRanges.splice(index + 1, 0, newDateRange());
        },

        removeDateRange: function (index) {
            if (this.dateRanges.length === 1) {
                return;
            }
            this.dateRanges.splice(index, 1);
        },
    },
};
</script>
